import { InMemoryCache } from "apollo-cache-inmemory";
import ApolloClient from "apollo-client";
import { createUploadLink } from "apollo-upload-client";
import React from "react";
import { ApolloProvider } from "react-apollo";
import ReactDOM from "react-dom";
import { I18n } from "react-polyglot";
import { Provider, Subscribe } from "unstated";
import App from "./App";
import RootModal from "./components/modals/RootModal";
import { api } from "./config";
import initialData from "./initialData.json";
import locale from "./locale/en.json";
import * as serviceWorker from "./serviceWorker";
import ConnectionStatus from "./state/ConnectionStatus";
import OfflineData from "./state/OfflineData";

import "./assets/css/argon-dashboard-react.min.css";
import "./assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/vendor/nucleo/css/nucleo.css";
import ModalContainer from "./state/ModalContainer";
import MaterialImportModal from "./components/modals/MaterialImportModal";

const cache = new InMemoryCache();
const link = createUploadLink({ uri: api.url });

const client = new ApolloClient({
  cache,
  connectToDevTools: true,
  link
});

if (!localStorage.getItem("buildups")) {
  localStorage.setItem("buildups", JSON.stringify(initialData.buildups));
}

if (!localStorage.getItem("templates")) {
  localStorage.setItem("templates", JSON.stringify(initialData.templates));
}

const Index = () => {
  return (
    <Subscribe to={[OfflineData, ConnectionStatus, ModalContainer]}>
      {(offlineData: any, connectionStatus: any, modal: any) => {
        offlineData.checkLocalStorage();
        connectionStatus.checkOnline();

        const showMaterialModal = () => {
          modal.showModal(MaterialImportModal);
        };

        return (
          <App
            showMaterialModal={showMaterialModal}
            setOnlineStatus={connectionStatus.setOnline}
            setOfflineStatus={connectionStatus.setOffline}
          />
        );
      }}
    </Subscribe>
  );
};

ReactDOM.render(
  <ApolloProvider client={client}>
    <I18n locale={"en"} messages={locale}>
      <Provider>
        <RootModal />
        <Index />
      </Provider>
    </I18n>
  </ApolloProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
